import { Component, OnInit, ViewChild } from '@angular/core';
import { TourNavigationService } from '../services/tour-navigation.service';
import { Steps } from '../shared/steps-model';
import { TourService } from '../services/tour.service';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';
import { EngineService } from '../services/engine.service';
import { ProToolsUiManagerService } from '../services/pro-tools-ui-manager.service';
import { AuthService } from '../services/auth.service';
import { HandrailDisplayService } from '../services/handrail-display.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { SaveProToolsActionsComponent } from '../save-pro-tools-actions/save-pro-tools-actions.component';
import { MatDialog } from '@angular/material';
import { DrawingsHolderService } from '../services/proTools/drawings-holder.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { pairwise } from 'rxjs/operators';
import { ProjectSaveService } from '../services/project-save.service';
import { DockModeService } from '../services/dock-mode.service';

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent implements OnInit {

  tourStep: number;
  isFirstStepChange: boolean = true;
  showProTools: boolean = false;
  proToolsActive: boolean = false;
  currentProjectKey: string = null;
  previousProjectKey: string = null;
  projectSaved = false;

  constructor(
    public dialog: MatDialog,
    public tourNavigationService: TourNavigationService,
    private vfTour: TourService,
    private railingGeneration: RailingGenerationService,
    private engineService: EngineService,
    private proToolsUiManagerService: ProToolsUiManagerService,
    private auth: AuthService,
    private handrailDisplayService: HandrailDisplayService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private drawings: DrawingsHolderService,
    private projectSrvc: ProjectManagerService,
    private projectSaveService: ProjectSaveService,
    public dockMode: DockModeService
  ) {
    this.dataForDisplayingMenuItemsService.firstStepChange.subscribe(value => {
      this.isFirstStepChange = value;
      this.drawings.setSaved(false);
    })
    this.dataForDisplayingMenuItemsService.startNewProj.subscribe(() => {
      this.changeStep(1);
      if (!this.step1.nativeElement.className.includes('active')) {
        this.step1.nativeElement.className += ' active';
      }
      if (this.step3 && this.step3.nativeElement && this.step3.nativeElement.className.includes('active')) {
        this.step3.nativeElement.className = this.step3.nativeElement.className.replace('active', '');
      }
    });
    this.proToolsUiManagerService.proToolsModActive.subscribe(value => {
      this.proToolsActive = value;
    });
  }

  @ViewChild('step1') step1;
  @ViewChild('step2') step2;
  @ViewChild('step3') step3;

  ngOnInit() {

    if (this.auth.getRole() == "admin" || this.auth.getRole() == "salesManager") {
      setTimeout(() => {
        this.showProTools = true;
      }, 0);
    }
    this.auth.isAuthorization.subscribe(auth => {
      if (this.auth.getRole() == "admin" || this.auth.getRole() == "salesManager") {
        setTimeout(() => {
          this.showProTools = true;
        }, 0);
      }
      else {
        setTimeout(() => {
          this.showProTools = false;
        }, 0);
      }
    });
    this.tourNavigationService.Navigator.subscribe(
      value => {
        this.tourStep = value;
      }
    );

    this.vfTour.showCurrentStep.subscribe((stepItem: Steps) => {
      this.tourStep = stepItem.step;
    });

    this.vfTour.resetTour.subscribe(value => this.tourStep = value);

    // FR-1021
    this.dataForDisplayingMenuItemsService.proToolsResetProj.pipe(pairwise())
      .subscribe(([previous, current]) => {
        this.previousProjectKey = previous;
        this.currentProjectKey = current;
      });

    //  FR-1021
    this.projectSaveService.projectSaved$.subscribe(() => this.projectSaved = true);
  }

  changeStep(step) {
    if (this.proToolsActive) {
      if (step < 3) {
        this.dialog.closeAll();
        // const dialogRef = this.dialog.open(SaveProToolsActionsComponent, {
        //   width: '40%'
        // });

        let items: any = this.drawings.getEditableItems();
        // FR-1021
        if (this.projectSaved && this.currentProjectKey !== this.previousProjectKey) items = {};
        this.projectSrvc.setProToolsItems(items);
        this.projectSrvc.updateProject();
        this.drawings.setSaved(true);

        // dialogRef.afterClosed().subscribe(result => {
        //   if (result || true) {

            if (step === 2) {
              if (this.isFirstStepChange) {
                this.railingGeneration.buildRailing(true);
                this.isFirstStepChange = false;
              }
              this.step1.nativeElement.className = 'step_1_top'
              this.handrailDisplayService.checkTiersStairsOnStage();

            }
            else if (step === 1) {
              this.step2.nativeElement.className = 'step_2_top'
            }

            this.dataForDisplayingMenuItemsService.setCurrentStep(step);

            this.engineService.setStep(step);

            if (this.showProTools) {
              this.proToolsUiManagerService.proToolsSwitcher(step);
            }
            this.projectSaved = false;
            this.previousProjectKey = this.currentProjectKey;
            return true;
        //   }
        //   // else {
        //   //   return false;
        //   // }
        // });
      }
    } else {
      if (step === 2) {
        if (this.isFirstStepChange) {
          this.railingGeneration.buildRailing(true);
          this.isFirstStepChange = false;
        }
        this.step1.nativeElement.className = 'step_1_top'
        this.handrailDisplayService.checkTiersStairsOnStage();

      }
      else if (step === 1) {
        this.step2.nativeElement.className = 'step_2_top'
      }

      this.dataForDisplayingMenuItemsService.setCurrentStep(step);

      this.engineService.setStep(step);

      if (this.showProTools) {
        this.proToolsUiManagerService.proToolsSwitcher(step);
      }

      this.previousProjectKey = this.currentProjectKey;
      return true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/nav-tabs/nav-tabs.component.ts